import { useCurrentFrame, useVideoConfig } from 'remotion';
import IdeShell from '../components/ide-shell';
import CodeEditorVideo from '../components/code-editor-video';
import OutputPanel from '../components/output-panel';
import MenuDropdown from '../components/menu-dropdown';

/**
 * Scene showing a menu dropdown action (e.g. Build > Build Solution).
 * Dropdown opens after a brief pause, items highlight on hover timing.
 */
export default function MenuActionScene({
  code = '',
  menu = 'Build',
  items = [],
  filename = 'Program.cs',
  projectName = 'HelloWorld',
  highlightAfterFrame = 60,
}) {
  const frame = useCurrentFrame();
  const lineCount = code ? code.split('\n').length : 1;

  // Menu dropdown position (px from left edge)
  const menuPositions = {
    'File': 46, 'Edit': 80, 'View': 114, 'Git': 156,
    'Project': 186, 'Build': 232, 'Debug': 274, 'Analyze': 318,
    'Tools': 370, 'Extensions': 408, 'Window': 480, 'Help': 530,
  };

  // Show dropdown after 15 frames
  const showDropdown = frame >= 15;

  // Apply highlight only after mouse has moved to the item
  const activeItems = items.map(item => ({
    ...item,
    highlight: item.highlight && frame >= highlightAfterFrame,
  }));

  return (
    <IdeShell projectName={projectName} filename={filename} step={1} lineCount={lineCount}
      overlay={showDropdown && (
        <MenuDropdown
          items={activeItems}
          x={menuPositions[menu] || 230}
          y={30}
        />
      )}
    >
      <CodeEditorVideo
        typedCode={code}
        step={1}
        lineCount={lineCount}
        projectName={projectName}
        filename={filename}
      />
      <OutputPanel buildLogs={[]} />
    </IdeShell>
  );
}
